import { getTvObject, tv } from '@costar-ui/cosmos';

var textFieldTV = getTvObject({
  slots: {
    base: 'group relative w-full',
    label: 'w-full',
    subText: 'w-full text-neutral-strong'
  },
  variants: {
    layout: {
      grid: {
        base: 'flex flex-col gap-1'
      },
      relative: {
        label: 'absolute -translate-y-full leading-5',
        subText: 'absolute bottom-0 translate-y-full'
      }
    },
    screenReaderOnly: {
      "true": {
        label: 'sr-only',
        subText: 'sr-only'
      }
    }
  }
});
var base = tv(textFieldTV);
var textFieldStyles = {
  base: base
};

export { textFieldStyles, textFieldTV };
//# sourceMappingURL=text-field.styles.esm.js.map
